import SuperFetch from '../../superFetch.js';

class WidgetApi {
  /**
   *  [위젯 등록] 상품 리스트 가져오기
   */
  getProductList = (data) => SuperFetch.post('/widget/insert/preparation/product/list', data);

  /**
   *  [위젯 등록] 브랜드 리스트 가져오기
   */
  getStoreList = (data) => SuperFetch.post('/widget/insert/preparation/store/list', data);

  /**
   *  [위젯 등록] 기획전 리스트 가져오기
   */
  getEventList = (data) => SuperFetch.post('/widget/insert/preparation/event/list', data);

  /**
   *  [위젯 등록] 홈 리스트 가져오기
   */
  getHomeList = (data) => SuperFetch.post('/widget/insert/preparation/home/list', data);

  /**
   *  [위젯 등록] 후기 리스트 가져오기
   */
  getReviewList = (data) => SuperFetch.post('/widget/insert/preparation/review/list', data);

  /**
   *  [위젯 등록] 태그 리스트 가져오기
   */
  getTagList = (data) => SuperFetch.post('/widget/insert/preparation/tag/list', data);

  /**
   *  [위젯 등록] 위젯 등록하기
   */
  insertWidget = (data) => SuperFetch.post('/widget/insert', data);

  /**
   *  [위젯 등록] 위젯 상품 아이템 EXCEL 다운로드하기
   */
  getWidgetItemProductExcelDownload = (data) =>
    SuperFetch.post('/widget/insert/preparation/product/list/excel/download', data);

  /**
   *  [위젯 등록] 선택된 위젯 상품 아이템 EXCEL 다운로드하기
   */
  getSelectedWidgetItemProductExcelDownload = (data) =>
    SuperFetch.post('/widget/insert/preparation/product/list/excel/download/selected', data);

  /**
   *  [위젯 등록] 위젯 상품 아이템 EXCEL 업로드하기
   */
  setWidgetItemProductExcelUpload = (data) =>
    SuperFetch.post('/widget/insert/preparation/product/list/excel/upload', data);

  /**
   *  [위젯 등록] 위젯 브랜드 아이템 EXCEL 다운로드하기
   */
  getWidgetItemStoreExcelDownload = (data) =>
    SuperFetch.post('/widget/insert/preparation/store/list/excel/download', data);

  /**
   *  [위젯 등록] 선택된 위젯 브랜드 아이템 EXCEL 다운로드하기
   */
  getSelectedWidgetItemStoreExcelDownload = (data) =>
    SuperFetch.post('/widget/insert/preparation/store/list/excel/download/selected', data);

  /**
   *  [위젯 등록] 위젯 브랜드 아이템 EXCEL 업로드하기
   */
  setWidgetItemStoreExcelUpload = (data) => SuperFetch.post('/widget/insert/preparation/store/list/excel/upload', data);

  /**
   *  [위젯 편집] 위젯 편집하기
   */
  editWidget = (data) => SuperFetch.post('/widget/edit', data);

  /**
   *  [위젯 삭제] 위젯 삭제하기
   */
  deleteWidget = (data) => SuperFetch.post('/widget/delete', data);

  /**
   *  [메뉴 등록 및 편집] 메뉴 가져오기
   */
  getHomeMenu = (data) => SuperFetch.post('/widget/homeMenu/list', data);

  /**
   *  [위젯 등록 및 편집] 메뉴 업데이트
   */
  updateHomeMenu = (data) => SuperFetch.post('/widget/homeMenu/edit', data);

  /**
   *  [서브 페이지 등록] 서브 페이지 등록 요청하기
   */
  insertSubPage = (data) => SuperFetch.post('/widget/home/sub/insert', data);

  /**
   *  [서브 페이지 편집] 서브 페이지 편집 요청하기
   */
  editSubPage = (data) => SuperFetch.post('/widget/home/sub/edit', data);

  /**
   *  [서브 페이지 리스트] 서브 페이지 리스트 요청하기
   */
  getSubPageList = (data) => SuperFetch.post('/widget/home/sub/list', data);

  /**
   *  [서브 페이지 상태] 서브 페이지 상태 업데이트하기
   */
  updateSubPageStatus = (data) => SuperFetch.post('/widget/home/sub/list/update/status', data);

  /**
   *  [메인 페이지 위젯 리스트] 메인 페이지 위젯 리스트 요청하기
   */
  getPageWidgetList = (data) => SuperFetch.post('/widget/home/main/widget/list', data);

  /**
   *  [서브 페이지 위젯 리스트] 서브 페이지 위젯 리스트 요청하기
   */
  getSubWidgetList = (data) => SuperFetch.post('/widget/home/sub/widget/list', data);

  /**
   *  [위젯 전체 리스트] 위젯 전체 리스트 요청하기
   */
  getWidgetAllList = (data) => SuperFetch.post('/widget/list/all', data);

  /**
   *  [위젯 비활성 리스트] 위젯 비활성 리스트 요청하기
   */
  getWidgetInactiveList = (data) => SuperFetch.post('/widget/list/inactive', data);

  /**
   *  [위젯 리스트] 위젯 미리보기 데이터 요청하기
   */
  getWidgetDetail = (data) => SuperFetch.post('/widget/detail', data);

  /**
   *  [위젯 리스트] 위젯 미리보기 데이터 요청하기
   */
  getWidgetPreviewData = (data) => SuperFetch.post('/widget/preview', data);

  /**
   *  [위젯 리스트] 위젯 미리보기 비교 데이터 요청하기
   */
  getWidgetPreviewCompareData = (data) => SuperFetch.post('/widget/preview/compare', data);

  /**
   *  [위젯 리스트] 변경된 위젯 리스트 저장하기
   */
  saveUpdatedWidgetList = (data) => SuperFetch.post('/widget/list/update/save', data);

  /**
   *  [위젯 리스트] 변경된 전체 위젯 리스트 저장하기
   */
  saveUpdatedAllWidgetList = (data) => SuperFetch.post('/widget/list/all/update/save', data);
}

export default new WidgetApi();
